  @if(loading()) {
  <div class='globalSpinner'>
    <mat-spinner strokeWidth="10"></mat-spinner>
  </div>
  }
